import { Theme } from '@mui/material';
import { BrandColors } from '../../constants/brandColors';
import { makeStyles } from 'tss-react/mui';

export const genericJourneyTheme = makeStyles()((theme: Theme) => {
  return {
    journeyThemeGrid: {
      minHeight: 'calc(100vh - 40px - 165px)',
      position: 'relative',
      padding: '2.5rem 1.5rem',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        minHeight: 'calc(100vh - 50px - 165px)',
        padding: '3.125rem 2.5rem',
      },
      [theme.breakpoints.up('lg')]: {
        minHeight: 'calc(100vh - 50px - 97px)',
        padding: '3.125rem 0rem',
      },
    },
    journeyThemePaper: {
      height: 'auto !important',
      maxHeight: '100%',
      position: 'relative',
      zIndex: 1,
      marginLeft: 'auto',
      marginRight: 'auto',
      borderRadius: '0.3125rem',
      maxWidth: '800px',
      padding: '1.25rem',
      wordWrap: 'break-word',
      [theme.breakpoints.up('lg')]: {
        padding: '1.25rem 1.875rem 1.25rem 1.875rem',
      },
    },
    bodyScroll: {
      overflow: 'auto',
    },
    upLayer: {
      position: 'relative',
      zIndex: 5,
    },
    hasScroll: {
      paddingRight: '0.8125rem',
    },
    customDivider: {
      backgroundColor: `${theme.palette.background.paper}`,
      height: '1px',
      boxShadow: `0px 2px 3px  ${BrandColors.blackWithOpacity15}`,
    },
    customBackButton: {
      height: '60px',
      marginTop: '-25px !Important',
      paddingTop: '1px',
    },
    newTaskPaper: {
      marginTop: '0',
      marginBottom: '0',
    },
    marginBottom0: {
      marginBottom: '0px',
    },
    journeyQuizPaper: {
      marginTop: '0px',
      width: 'auto !important',
    },
    quizFontStyle: {
      '& .heading': {
        fontSize: '20px',

        lineHeight: '1.875rem',
      },

      '& p, & li': {
        fontSize: '14px',

        lineHeight: '1.25rem',
      },
    },
    width100: {
      width: '100%',
    },
    paddingBottom: {
      paddingBottom: '1.875rem',
    },
    textAlignLeft: {
      textAlign: 'left',
    },
    quizBlockFontStyle: {
      '& .heading, & .feedback-heading': {
        fontSize: '14px !important',

        lineHeight: '1.25rem',
      },

      '& p, & li': {
        fontSize: '12px !important',

        lineHeight: '1.125rem',
      },
    },
    summaryFeedback: {
      position: 'relative',
      top: '-85px',
      [theme.breakpoints.up('sm')]: {
        top: '-110px',
      },
    },
    linkGrid: {
      flexWrap: 'wrap',
      '& .link': {
        borderBottom: `1px solid ${theme.palette.background.default}`,
        paddingTop: '1.25rem',
        paddingBottom: '1.25rem',
        '&:last-child': {
          borderBottom: '0',
          paddingBottom: '0',
        },
      },
    },
    fixedBG: {
      position: 'fixed',
      left: 0,
      top: 0,
      height: '100%',
      width: '100%',
      zIndex: 0,
    },
    ImgContainer: {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
    },
    languageOverlay: {
      '&::before': {
        content: '""',
        position: 'fixed',
        left: 0,
        top: 0,
        backgroundColor: `${BrandColors.blackWithOpacity25}`,
        height: '100%',
        width: '100%',
      },
    },
    simplifiedJourneyThemePaper: {
      height: 'auto !important',
      maxHeight: '100%',
      position: 'relative',
      zIndex: 1,
      marginLeft: 'auto',
      marginRight: 'auto',
      borderRadius: '0.3125rem',
      padding: '0.25rem 0.5rem',
    },
  };
});
